import React, {FC} from 'react';
import styled from 'styled-components';

import {isConversationOnelinerFact} from '../../../../../../libs/shared/core/src/models/api/factModel';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {SynopsisQuickAction, SynopsisQuickActions, SynopsisQuickActionsEnum} from './synopsisQuickAction';
import {useSynopsisViewerContext} from './synopsisViewerContext';

interface SynopsisOneLinerProps {
  conversation: ConversationModel;
}

const StyledOneLinerDiv = styled.div`
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.bold};
  line-height: 1.4;
`;

export const SynopsisOneLiner: FC<SynopsisOneLinerProps> = ({conversation}) => {
  const {onFeedbackAction} = useSynopsisViewerContext();

  const onelinerFact = conversation.facts.find(isConversationOnelinerFact);
  if (!onelinerFact) {
    return null;
  }

  return (
    <SynopsisQuickActions
      actions={
        <SynopsisQuickAction
          actionId={SynopsisQuickActionsEnum.FEEDBACK}
          onClick={() => onFeedbackAction({type: 'oneliner'})}
        />
      }
      right={0}
      bottom={0}
    >
      <StyledOneLinerDiv>{onelinerFact.content}</StyledOneLinerDiv>
    </SynopsisQuickActions>
  );
};
